<script setup lang="ts">
import { ref } from 'vue';

import { AppSvgIcon, AppFadeInOutTransition } from '@libs/ui';

import { MonthsSelectorInnerView } from '../priceRibbon';
import type { PriceRibbonMonth } from '../priceRibbon';

interface PriceCalendarHeaderProps {
  months: PriceRibbonMonth[];
  selectedMonthIsoDate: string;
}

const props = defineProps<PriceCalendarHeaderProps>();

const shouldShowMonthsSelector = ref<boolean>(false);
</script>

<template>
  <div class="price-calendar-header">
    <!-- TODO: Translation -->
    <div class="departure-text">Departure anytime in</div>
    <div
      class="month-text"
      @click="shouldShowMonthsSelector = !shouldShowMonthsSelector"
    >
      December, 2024
      <AppSvgIcon name="chevronDown" size="16" color="color-black" />
    </div>
    <div class="months">
      <AppFadeInOutTransition>
        <MonthsSelectorInnerView
          v-if="shouldShowMonthsSelector"
          :months="props.months"
          :selected-month-iso-date="props.selectedMonthIsoDate"
        />
      </AppFadeInOutTransition>
    </div>
  </div>
</template>

<style scoped lang="scss">
.price-calendar-header {
  overflow-x: scroll;
  width: 100%;

  .departure-text {
    @include font-label-s-light;
    color: var(--color-secondary-60);
  }

  .month-text {
    font: var(--font-label-xl-bold);
    color: var(--color-black);

    margin-bottom: var(--spacing-8);

    display: flex;
    align-items: center;
    gap: var(--spacing-8);
  }

  .months {
    background: var(--color-white);
    position: absolute;
    width: 590px;
  }
}
</style>
